
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { LiveEventsConfigInterface } from './liveevents.types';

@Component
export default class LiveEventsConfigComponent extends Vue {
  @Prop() config!: LiveEventsConfigInterface;

  @Watch('config')
  onConfigChange(value: LiveEventsConfigInterface) {
    this.$emit('update:config', value);
  }
};

